import { useState, useEffect } from "react";
// export const useFormFields = (initialState) => {
//   const [fields, setValues] = useState(initialState);
//
//   return [
//     fields,
//     (event) => {
//       setValues({
//         ...fields,
//         [event.target.id]: event.target.value
//       });
//     }
//   ];
// };

export const useMediaQuery = (query) => {
  const mediaMatch = window.matchMedia(query);
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e) => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  }, []);
  return matches;
};
